var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.screenWidth > 768)?_c('pc'):_c('mobile')
}
var staticRenderFns = []

export { render, staticRenderFns }